import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sku: {
    id: 'XNd7Ky',
    defaultMessage: 'SKU: {sku}',
    description: 'SKU of the product',
  },
});
